module.exports = __webpack_public_path__ + "img/cecilia-bolan.b93582b7.jpg";